import Nullstack from 'nullstack';
export default function IconBusOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-bus-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M16.18 16.172a2 2 0 0 0 2.652 2.648"
  }), "   ", Nullstack.element("path", {
    d: "M4 17h-2v-11a1 1 0 0 1 1 -1h2m4 0h8c2.761 0 5 3.134 5 7v5h-1m-5 0h-8"
  }), "   ", Nullstack.element("path", {
    d: "M16 5l1.5 7h4.5"
  }), "   ", Nullstack.element("path", {
    d: "M2 10h8m4 0h3"
  }), "   ", Nullstack.element("path", {
    d: "M7 7v3"
  }), "   ", Nullstack.element("path", {
    d: "M12 5v3"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}